<template>
    <div>
        <el-container direction="vertical">
            <div style="background-color: rgb(255, 255, 255); border: 1px solid #eee;">
                <el-row direction="horizontal" style="margin-top: 10px;">
                    <el-col :span="6">
                        <el-card :style="{ 'margin-left': '10px', 'width': '210px', 'background-color': regularColor }"
                            @click.native="cardClick(1)">
                            <div>
                                <el-statistic :value="overviewData1.value" :title="overviewData1.title"
                                    :value-style="{ color: 'cornflowerblue' }">
                                    <template slot="prefix">
                                        <i class="el-icon-s-flag" style="color: cornflowerblue"></i>
                                    </template>
                                </el-statistic>
                            </div>
                        </el-card>
                    </el-col>

                    <el-col :span="6">
                        <el-card :style="{ 'margin-left': '10px', 'width': '210px', 'background-color': previewColor }"
                            @click.native="cardClick(0)">
                            <div>
                                <el-statistic :value="overviewData2.value" :title="overviewData2.title"
                                    :value-style="{ color: 'red' }">
                                    <template slot="prefix">
                                        <i class="el-icon-s-flag" style="color: red"></i>
                                    </template>
                                </el-statistic>
                            </div>
                        </el-card>
                    </el-col>

                    <!-- <el-col :span="6">
                        <el-card style="margin-left: 10px;width: 210px;">
                            <div>
                                <el-statistic :value="overviewData3.value" :title="overviewData3.title"
                                    :value-style="{ color: 'cornflowerblue' }">
                                    <template slot="prefix">
                                        <i class="el-icon-s-flag" style="color: cornflowerblue"></i>
                                    </template>
                                </el-statistic>
                            </div>
                        </el-card>
                    </el-col>

                    <el-col :span="6">
                        <el-card style="margin-left: 10px;width: 210px;">
                            <div>
                                <el-statistic :value="overviewData4.value" :title="overviewData4.title"
                                    :value-style="{ color: 'red' }">
                                    <template slot="prefix">
                                        <i class="el-icon-s-flag" style="color: red"></i>
                                    </template>
                                </el-statistic>
                            </div>
                        </el-card>
                    </el-col> -->
                </el-row>

                <div>
                    <el-form :model="formData" label-width="90px" :inline="true" style="margin-top: 40px;">
                        <!-- <el-form-item label="检测机构">
                            <patientTree @input="input"></patientTree>
                        </el-form-item> -->
                        <el-form-item label="患者姓名">
                            <el-input v-model="formData.measurerName" style="width: 160px"></el-input>
                        </el-form-item>
                        <el-form-item label="血糖类型">
                            <el-select v-model="formData.measureStatus" placeholder="全部" style="width: 170px">
                                <el-option label="全部" :value="null"></el-option>
                                <el-option label="空腹血糖" value="空腹血糖"></el-option>
                                <el-option label="早餐后" value="早餐后"></el-option>
                                <el-option label="早餐后2小时" value="早餐后2小时"></el-option>
                                <el-option label="午餐前" value="午餐前"></el-option>
                                <el-option label="午餐后两小时" value="午餐后两小时"></el-option>
                                <el-option label="晚餐前" value="晚餐前"></el-option>
                                <el-option label="晚餐后两小时" value="晚餐后两小时"></el-option>
                                <el-option label="随机" value="随机"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="血糖危险">
                            <el-select v-model="formData.critical" placeholder="全部" style="width: 170px">
                                <el-option label="全部" :value="null"></el-option>
                                <el-option label="危急值" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="访问方式">
                            <el-select v-model="formData.measurerType" placeholder="全部" style="width: 170px">
                                <el-option label="全部" :value="null"></el-option>
                                <el-option label="门诊" value="门诊"></el-option>
                                <el-option label="家庭" value="家庭"></el-option>
                                <el-option label="电话" value="电话"></el-option>
                                <el-option label="视频" value="视频"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="来源">
                            <el-select v-model="formData.fromSource" style="width: 170px">
                                <el-option v-for="x in sourceOptions" :key="x.value" :label="x.label" :value="x.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="测量时间">
                            <el-date-picker v-model="valueData" type="daterange" align="right" unlink-panels
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" style="margin-left: 10px"
                                @click="getBloodSugarList">查询</el-button>
                        </el-form-item>
                        <!-- <el-form-item>
                            <el-button type="primary" @click="reportExportToExcel">导出</el-button>
                        </el-form-item> -->
                    </el-form>
                </div>

                <el-table class="inspectionTable" v-loading="listLoading" :data="manageList" fit>
                    <el-table-column width="160" align="center" label="测量时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.time || "-" }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="姓名">
                        <template slot-scope="scope">
                            <span>{{ scope.row.measurerName || "-" }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="血糖类型">
                        <template slot-scope="scope">
                            <span>{{ scope.row.measureStatus || "-" }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="血糖值">
                        <template slot-scope="scope">
                            <span>{{ scope.row.bloodSugar || "-" }}</span>
                            <span :class="scope.row.riskType" style="margin-left: 5px;margin-top:0px;"></span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="来源">
                        <template slot-scope="scope">
                            <span>{{ scope.row.fromSource || '-' }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column width="160" align="center" label="三级医师（糖）">
                        <template slot-scope="scope">
                            <span>{{ scope.row.doctorLevel3Name || "-" }}</span>
                        </template>
                    </el-table-column>

                    <!-- <el-table-column align="center" label="规范管理">
                        <template slot-scope="scope">
                            <span>{{ scope.row.isDiabetStdManage == 1 ? "是" : "--" }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column width="200" align="center" label="测量机构">
                        <template slot-scope="scope">
                            <span>{{ scope.row.dataSources }}</span>
                        </template>
                    </el-table-column> -->

                    <el-table-column fixed="right" width="250" align="center" label="操作">
                        <template slot-scope="scope">
                            <el-button style="margin-left: 0px; align-self: center" type="text"
                                @click="patientsDetail(scope.row)">
                                健康档案
                            </el-button>

                            <el-button style="margin-left: 5px; align-self: center" type="text"
                                @click="codiag(scope.row)">一键协诊</el-button>

                            <el-button style="margin-left: 5px; align-self: center" type="text"
                                @click="patientFollowup(scope.row)">随访</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize" @pagination="turnToPage" />

                <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>
                <codiagDiag v-if="codiagDiagVisible" ref="codiagDiagRef">
                </codiagDiag>
                <new-follow-up v-if="newFollowUpVisible" ref="newFollowUpRef"></new-follow-up>
            </div>
        </el-container>
    </div>
</template>

<script>
import {
    getBloodSugarList,
    getUserInfos,
    turnToBloodSugarList,
    getSearchList,
    getFollowupValue,
    getListByTime,
    reportToExcel,
    getLisMeasureTips,
    getSysDicList
} from "@/api/health/Patients";
import Pagination from "@/components/Pagination";
import patientDetail from "@/views/patient/patientDetail";
import patientTree from '@/components/selectTree';
import { Loading } from "element-ui";
import moment from "moment";
import { color } from "echarts";
import codiagDiag from "../integration/codiagDiag.vue";
import newFollowUp from "../followup/newFollowUp.vue";

export default {
    components: {
        Pagination,
        patientTree,
        patientDetail,
        codiagDiag,
        newFollowUp
    },
    data() {
        return {
            patientDetailVisible: false,
            codiagDiagVisible: false,
            newFollowUpVisible: false,
            formData: {
                doctorLevel3Name: null,
                risk: null,
                reachTarget: 1,
                critical: null,
                bloodsugarLe: 1,
                bloodsugarGe: 30,
                measurerName: null,
                codiagStatus: null,
                isDiabetStdManage: null,
                measureType: null,
                measurerType: null,
                measureStatus: null,
                fromSource: null,
                codiagCountGe: null,
                measureCountGe: null,
                measureCountLe: null,
                managerHospitals: [],
                diseaseFilters: null,
                startTime: null,
                endTime: null,
            },
            data: [],
            valueData: null,
            manageList: [],
            listLoading: false,
            total: 0,
            loadingOptions: {
                text: "正在导出...",
                background: "rgba(0, 0, 0, 0.6)",
            },
            listQuery: {
                pageNum: 1,
                pageSize: 10,
            },
            diseaseFilters: ["全部"],
            diseaseFiltersOptions: [
                {
                    value: "全部",
                    label: "全部",
                    disabled: false,
                },
                {
                    value: "糖尿病",
                    label: "糖尿病人群",
                    disabled: false,
                },
                {
                    value: "高血压",
                    label: "高血压人群",
                    disabled: false,
                },
                {
                    value: "高血脂",
                    label: "高血脂人群",
                    disabled: false,
                },
                {
                    value: "易患人群",
                    label: "易患人群",
                    disabled: false,
                },
                {
                    value: "正常人群",
                    label: "正常人群",
                    disabled: false,
                }
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "今天",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime());
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
            exportBody: {
                url: "/business/iotBloodSugar/list",
                headers: ['测量时间', '姓名', '身份证号', '血糖类型', '血糖值', '三级医师（糖）', '规范管理', '测量方式', '测量机构', '所属机构', '协诊次数', '协诊状态', '协诊人', '协诊时间'],
                keys: ['time', 'measurerName', 'measurerIdentityCard', 'measureStatus', 'bloodSugar', 'doctorLevel3Name', 'isDiabetStdManage', 'measurerType', 'dataSources', 'managerHospital', 'coDiagCount', 'codiagStatus', 'coDiagDoctorName', 'codiagTime'],
                body: null,
            },
            overviewData1: {
                value: 0,
                title: "血糖检测达标人次",
            },
            overviewData2: {
                value: 0,
                title: "血糖检测未达标人次",
            },
            overviewData3: {
                value: 0,
                title: "血糖检测规范人数",
            },
            overviewData4: {
                value: 0,
                title: "血糖检测不规范人数",
            },
            regularColor: '#ECF5FF',
            previewColor: '#ffffff',
            sourceOptions: [], // 指标来源
        };
    },
    created() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        this.valueData = [start, end];
        this.getBloodSugarList();
        this.getListTipsMethod();
        this.getSourceSystemDictList("指标来源");
    },
    watch: {
        "formData.measureCountGe": {
            handler(newval) {
                if (newval == 1) {
                    this.formData.measureCountLe = 2;
                } else if (newval == 3) {
                    this.formData.measureCountLe = null;
                } else {
                    this.formData.measureCountLe = null;
                }
            },
            immediate: true,
            deep: true,
        },
        "formData.measurerType": {
            handler(newV) {
                this.formData.measureType = newV;
            },
            immediate: true,
        },
    },
    methods: {
        getSourceSystemDictList(typeName) {
            var typeData = {
                "typeName": typeName
            };
            getSysDicList(typeData).then(res => {
                var records = [];
                if (res.msg == "success") {
                    var data = res.data;
                    records = data.records;
                }
                this.sourceOptions = records?.map(x => ({ label: x.name, value: x.name }));
                this.sourceOptions = [{ label: "全部", value: null }, ...this.sourceOptions]
            }).catch(err => {
                console.log(err);
            })
        },
        getListTipsMethod() {
            var param = { type: '血糖' };
            getLisMeasureTips(param).then((res) => {
                if (res.msg == "success") {
                    var data = res.data[0];
                    this.overviewData1.value = data.countReachTarget;
                    this.overviewData2.value = data.countUnReachTarget;
                }
            }).catch(error => {
                console.log(error);
            });
        },
        //查询结果导出
        reportExportToExcel() {
            console.log(
                "查询结果导出",
                `表格${moment(new Date()).format("YYYYMMDDHHmm")}.xlsx`
            );

            let loadingInstance = Loading.service(this.loadingOptions);

            this.exportBody.url = '/business/iotBloodSugar/list?page=' + this.listQuery.pageNum + '&pageSize=' + this.listQuery.pageSize;
            this.exportBody.body = this.formData;
            console.log("导出表格请求body：", this.exportBody);

            reportToExcel(this.exportBody)
                .then((res) => {
                    console.log("查询表格导出====", res);

                    this.$nextTick(() => {
                        loadingInstance.close();
                    });

                    let blob = new Blob([res], { type: "application/force-download" });
                    console.log(blob);
                    let fileReader = new FileReader();
                    fileReader.readAsDataURL(blob);
                    fileReader.onload = (e) => {
                        let a = document.createElement("a");
                        a.download = `血糖检测${moment(new Date()).format(
                            "YYYYMMDDHHmm"
                        )}.xlsx`;
                        a.href = e.target.result;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    };
                })
                .catch((error) => {
                    this.$nextTick(() => {
                        loadingInstance.close();
                    });

                    console.log(error);

                    this.$message({
                        message: "导出失败",
                        type: "error",
                    });
                });
        },
        //一键协诊
        codiag(rowValue) {
            this.codiagDiagVisible = true;

            rowValue.refType = '血糖';
            rowValue.codiagServiceName = '血糖';
            rowValue.codiagStatus = '待协诊';
            console.log('血糖检测一键协诊：', rowValue);

            this.$nextTick(() => {
                this.$refs['codiagDiagRef'].init(rowValue);
            })
        },
        //随访
        patientFollowup(row) {
            this.newFollowUpVisible = true;
            row.serviceName = '糖尿病随访';
            this.$nextTick(() => {
                this.$refs["newFollowUpRef"].init(row);
            });
        },
        upDataList() {
            this.getBloodSugarList();
        },
        cardClick(value) {
            console.log('达标：', value);
            if (value == 1) {
                //达标
                this.regularColor = '#ECF5FF';
                this.previewColor = '#ffffff';
            } else {
                //未达标
                this.regularColor = '#ffffff';
                this.previewColor = '#ECF5FF';
            }

            this.formData.reachTarget = value;
            this.getBloodSugarList();
        },
        getBloodSugarList() {
            if (this.diseaseFilters.length > 0) {
                var filter = this.diseaseFilters[0];
                if (filter == "全部") {
                    this.formData.diseaseFilters = null;
                } else {
                    this.formData.diseaseFilters = this.diseaseFilters;
                }
            } else {
                this.formData.diseaseFilters = null;
            }

            if (this.formData.bloodsugarLe > this.formData.bloodsugarGe) {
                this.$message({
                    message: "血糖范围左侧值必须小于右侧值，请重选后再次查询！",
                    type: "error",
                });
                return;
            }
            if (this.valueData != null) {
                this.formData.startTime = this.valueData[0]
                    ? this.getParseDate(this.valueData[0], 1)
                    : null;
                this.formData.endTime = this.valueData[0]
                    ? this.getParseDate(this.valueData[1], 2)
                    : null;
            } else {
                this.formData.startTime = null;
                this.formData.endTime = null;
            }
            const params = this.formData;
            this.listLoading = true;

            console.log("formdata:", this.formData);
            getBloodSugarList({ ...params }).then((res) => {
                this.listLoading = false;
                console.log(res);
                if (res.msg == "success") {
                    this.manageList = res.data.records;
                    this.total = res.data.total;

                    this.manageList.forEach((item, index) => {
                        this.manageList[index].riskType = this.setRiskType(item)
                            ? this.setRiskType(item)
                            : "labelNone";
                    });
                }
            });
        },
        setRiskType(row) {
            if (row.codiagStatus == 0) {
                if (row.risk == 3) {
                    return "labelRed";
                } else if (row.risk == 2) {
                    return "labelYellow";
                } else if (row.risk == 1) {
                    return "labelGreen1";
                }
            } else {
                return "labelNone";
            }
        },
        // 跳转至相应病人档案详情页
        patientsDetail(row) {
            // if (!row.ehr) {
            //     this.$message({
            //         message: "该患者尚未建立个人档案，请先建立！",
            //         type: "warning",
            //     });
            // } else {
            //     this.patientDetailVisible = true;
            //     this.$nextTick(() => {
            //         this.$refs["PatientDetailRef"].init(row.ehr);
            //     });
            // }

            this.patientDetailVisible = true;
            if (row.idcard == null) {
                row.idcard = row.measurerIdentityCard;
            }
            this.$nextTick(() => {
                this.$refs["PatientDetailRef"].init(row);
            });
        },
        // 获取系统时间
        getSystemTime() {
            var newTime = new Date(time);
            // 获取完整的年份(4位)
            var year = newTime.getFullYear();
            // 获取月份(0-11,0代表1月)
            var month = newTime.getMonth() + 1;
            // 获取日期(1-31)
            var date = newTime.getDate();

            return (
                year +
                "-" +
                (month < 10 ? "0" + month : month) +
                "-" +
                (date < 10 ? "0" + date : date)
            );
        },
        // 日期格式转化
        getParseDate(time, type) {
            if (type == 1) {
                var newTime = new Date(time);
            } else if (type == 2) {
                var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
            }
            // 获取完整的年份(4位)
            var year = newTime.getFullYear();
            // 获取月份(0-11,0代表1月)
            var month = newTime.getMonth() + 1;
            // 获取日期(1-31)
            var date = newTime.getDate();

            return (
                year +
                "-" +
                (month < 10 ? "0" + month : month) +
                "-" +
                (date < 10 ? "0" + date : date)
            );
        },
        // 获取机构数组
        input(value) {
            this.formData.managerHospitals = value;
        },
        // 导航跳转查询列表页
        turnToPage() {
            if (this.formData.bloodsugarLe > this.formData.bloodsugarGe) {
                this.$message({
                    message: "血糖范围左侧值必须小于右侧值，请重选后再次查询！",
                    type: "error",
                });
                return;
            }
            if (this.valueData != null) {
                this.formData.startTime = this.valueData[0]
                    ? this.getParseDate(this.valueData[0], 1)
                    : null;
                this.formData.endTime = this.valueData[1]
                    ? this.getParseDate(this.valueData[1], 2)
                    : null;
            } else {
                this.formData.startTime = null;
                this.formData.endTime = null;
            }
            let params = Object.assign({}, this.listQuery, this.formData);
            this.listLoading = true;
            turnToBloodSugarList(params).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.manageList = res.data.records;
                    this.total = res.data.total;

                    this.manageList.forEach((item, index) => {
                        this.manageList[index].riskType = this.setRiskType(item)
                            ? this.setRiskType(item)
                            : "labelNone";
                    });
                }
            });
        },
        // 修改条纹颜色
        tableRowClassName({ row, rowIndex }) {
            if (row.codiagStatus == 0) {
                if (row.risk == 3) {
                    return "light-row";
                } else if (row.risk == 2) {
                    return "aterrimus-row";
                } else if (row.risk == 1) {
                    // return "green-row";
                }
            } else {
                return;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.labelNone {
    display: none;
}

.labelRed {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    border: 1px solid gray;
    color: white;
    background: red;
    display: inline-block;
}

.labelYellow {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    border: 1px solid gray;
    color: white;
    background: yellow;
    display: inline-block;
}

.labelGreen1 {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    border: 1px solid gray;
    color: white;
    background: green;
    display: inline-block;
}

.inspectionTable {
    ::v-deep {
        .light-row {
            background: rgba(255, 0, 0, 0.579) !important;
        }

        .aterrimus-row {
            //黄
            background: yellow !important;
        }

        .green-row {
            background: greenyellow;
        }

        .el-table__cell {
            height: 50px !important;
        }
    }
}

.form ::v-deep {
    .el-form-item {
        display: inline-flex;
    }

    // .el-input--medium .el-input__inner {
    //   width: 209px !important;
    // }

    .el-form-item__content {
        margin-left: 5px !important;
    }
}
</style>